
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.661 16.15l2.158-1.186a.811.811 0 01.415-.105c.305 0 .582.158.72.396l1.936 3.216a.71.71 0 01.11.394.788.788 0 01-.416.686L15.957 21c-3.982-2.056-5.559-3.927-7.384-6.904C6.774 11.118 6 8.851 6 4.555l2.627-1.45A.825.825 0 019.043 3c.304 0 .581.159.719.396l1.937 3.189c.082.132.11.264.11.422a.72.72 0 01-.415.658L9.236 8.851l4.425 7.299z","fill":"currentColor"}})])
          )
        }
      }
    